<template>
  <layout>
    <div class="page golden-ticket">
      <div class="uk-container uk-container-expand">
        <div class="golden-ticket-form-container">
          <iframe
            src="https://preview.mailerlite.io/forms/866304/169631429442930411/share"
            width="100%"
            height="1214"
            frameborder="0"
            scrolling="no"
            style="border: none"
            title="Golden Ticket Form"
          ></iframe>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
export default {
  name: 'GoldenTicket',
  metaInfo() {
    return {
      title: 'Golden Ticket | Nathan Nankirvis',
      meta: [
        {
          name: 'description',
          content: 'Golden Ticket form - Nathan Nankervis',
        },
      ],
    }
  },
}
</script>

<style scoped>
.golden-ticket {
  min-height: 100vh;
}

.golden-ticket-form-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 2rem 0;
}

.golden-ticket-form-container iframe {
  width: 100%;
  min-height: 1214px;
  border: none;
  display: block;
}

/* Ensure no double scrolling */
.golden-ticket .uk-container {
  overflow: hidden;
}

@media (max-width: 768px) {
  .golden-ticket-form-container {
    padding: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/GoldenTicket.vue